import React, { memo } from 'react'
import { Info } from '../images/svg/info'

const Input = ({
  error,
  label,
  type = 'text',
  value,
  placeholder,
  className,
  required,
  onChange,
}) => {
  const errorClass = error ? 'error' : ''
  return (
    <div className={`input-block ${errorClass}`}>
      <div className="input-info">
        {label ? (
          <label className={`label ${errorClass}`}>
            {label}
            {required && <span className="asteriks">*</span>}
          </label>
        ) : null}
        {error ? <div className="error">{error}</div> : null}
      </div>
      <div className="input-box">
        <input
          type={type}
          value={value}
          placeholder={placeholder}
          className={`input ${className} ${errorClass}`}
          required={required}
          onInput={(e) => onChange(e.target.value)}
        />
        {error ? <Info className="error-icon" color={'#DF2A50'} /> : null}
      </div>
    </div>
  )
}

export default memo(Input)
